/* global axios */
import ApiClient from './ApiClient';

class ContactAttributesReportsAPI extends ApiClient {
  constructor() {
    super('contact_attributes_reports', {
      accountScoped: true,
      apiVersion: 'v2',
    });
  }

  getReport({
    from,
    to,
    attributeKey,
    attributeValue,
    groupBy,
    dateAttributeKey,
    dateFilterType,
  }) {
    return axios.get(`${this.url}`, {
      params: {
        since: from,
        until: to,
        attribute_key: attributeKey,
        attribute_value: attributeValue,
        group_by: groupBy,
        date_attribute_key: dateAttributeKey,
        date_filter_type: dateFilterType,
      },
    });
  }

  getAttributes() {
    return axios.get(`${this.url}/attributes`);
  }

  getByDateAttribute({ from, to, attributeKey, groupBy }) {
    return axios.get(`${this.url}/by_date_attribute`, {
      params: {
        since: from,
        until: to,
        attribute_key: attributeKey,
        group_by: groupBy,
      },
    });
  }
}

export default new ContactAttributesReportsAPI();
